import React from "react";
import { Remark } from "react-remark";
import { InlineDiv } from "./elements";

const MarkdownSpan = ({ text }) => {
  return (
    <Remark
      rehypeReactOptions={{
        components: {
          p: (props) => <InlineDiv {...props} />,
          div: (props) => <InlineDiv {...props} />,
        },
      }}
    >
      {text}
    </Remark>
  );
};
export default MarkdownSpan;
